module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "tftable",
    attrs: {
      "id": "tfhover",
      "border": "1"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("增值税税控系统专用设备费及技术维护费（来源减免税明细台账）")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_1_1),
      expression: "A_1_1"
    }],
    domProps: {
      "value": (_vm.A_1_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_1_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_1_2),
      expression: "A_1_2"
    }],
    domProps: {
      "value": (_vm.A_1_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_1_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.A_1_3))]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_1_4),
      expression: "A_1_4"
    }],
    domProps: {
      "value": (_vm.A_1_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_1_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.A_1_5))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("分支机构预征缴纳税款 ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_2_1),
      expression: "A_2_1"
    }],
    domProps: {
      "value": (_vm.A_2_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_2_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_2_2),
      expression: "A_2_2"
    }],
    domProps: {
      "value": (_vm.A_2_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_2_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.A_2_3))]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_2_4),
      expression: "A_2_4"
    }],
    domProps: {
      "value": (_vm.A_2_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_2_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.A_2_5))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_vm._v("建筑服务预征缴纳税款 ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_3_1),
      expression: "A_3_1"
    }],
    domProps: {
      "value": (_vm.A_3_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_3_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_3_2),
      expression: "A_3_2"
    }],
    domProps: {
      "value": (_vm.A_3_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_3_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.A_3_3))]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_3_4),
      expression: "A_3_4"
    }],
    domProps: {
      "value": (_vm.A_3_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_3_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.A_3_5))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("4")]), _vm._v(" "), _c('td', [_vm._v("销售不动产预征缴纳税款 ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_4_1),
      expression: "A_4_1"
    }],
    domProps: {
      "value": (_vm.A_4_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_4_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_4_2),
      expression: "A_4_2"
    }],
    domProps: {
      "value": (_vm.A_4_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_4_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.A_4_3))]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_4_4),
      expression: "A_4_4"
    }],
    domProps: {
      "value": (_vm.A_4_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_4_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.A_4_5))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("5")]), _vm._v(" "), _c('td', [_vm._v("出租不动产预征缴纳税款")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_5_1),
      expression: "A_5_1"
    }],
    domProps: {
      "value": (_vm.A_5_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_5_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_5_2),
      expression: "A_5_2"
    }],
    domProps: {
      "value": (_vm.A_5_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_5_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.A_5_3))]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_5_4),
      expression: "A_5_4"
    }],
    domProps: {
      "value": (_vm.A_5_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_5_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.A_5_5))])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('tr', [_c('td', [_vm._v("6")]), _vm._v(" "), _c('td', [_vm._v("一般项目加计抵减额计算")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_6_1),
      expression: "A_6_1"
    }],
    domProps: {
      "value": (_vm.A_6_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_6_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_6_2),
      expression: "A_6_2"
    }],
    domProps: {
      "value": (_vm.A_6_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_6_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_6_3),
      expression: "A_6_3"
    }],
    domProps: {
      "value": (_vm.A_6_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_6_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.A_6_4))]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_6_5),
      expression: "A_6_5"
    }],
    domProps: {
      "value": (_vm.A_6_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_6_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.A_6_6))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("7")]), _vm._v(" "), _c('td', [_vm._v("即征即退项目加计抵减额计算")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_7_1),
      expression: "A_7_1"
    }],
    domProps: {
      "value": (_vm.A_7_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_7_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_7_2),
      expression: "A_7_2"
    }],
    domProps: {
      "value": (_vm.A_7_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_7_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_7_3),
      expression: "A_7_3"
    }],
    domProps: {
      "value": (_vm.A_7_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_7_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.A_7_4))]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_7_5),
      expression: "A_7_5"
    }],
    domProps: {
      "value": (_vm.A_7_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_7_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.A_7_6))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("8")]), _vm._v(" "), _c('td', [_vm._v("合计")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_8_1),
      expression: "A_8_1"
    }],
    domProps: {
      "value": (_vm.A_8_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_8_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_8_2),
      expression: "A_8_2"
    }],
    domProps: {
      "value": (_vm.A_8_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_8_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_8_3),
      expression: "A_8_3"
    }],
    domProps: {
      "value": (_vm.A_8_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_8_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.A_8_4))]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_8_5),
      expression: "A_8_5"
    }],
    domProps: {
      "value": (_vm.A_8_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_8_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.A_8_6))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("增值税纳税申报表附列资料（四）")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center",
      "font-size": "12px"
    },
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("（税额抵减情况表）")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("税款所属时间： 年 月 日 至 年 月 日")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("纳税人名称：（公章）")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("金额单位：元至角分")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("抵减项目")]), _vm._v(" "), _c('td', [_vm._v("期初余额")]), _vm._v(" "), _c('td', [_vm._v("本期发生额")]), _vm._v(" "), _c('td', [_vm._v("本期应抵减税额")]), _vm._v(" "), _c('td', [_vm._v("本期实际抵减税额")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("期末余额")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("3=1+2")]), _vm._v(" "), _c('td', [_vm._v("4≤3")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("5=3-4")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("二、加计抵减情况")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("抵减项目")]), _vm._v(" "), _c('td', [_vm._v("期初余额")]), _vm._v(" "), _c('td', [_vm._v("本期发生额")]), _vm._v(" "), _c('td', [_vm._v("本期应抵减税额")]), _vm._v(" "), _c('td', [_vm._v("本期实际抵减税额")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("期末余额")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_vm._v("4=1+2-3")]), _vm._v(" "), _c('td', [_vm._v("5")]), _vm._v(" "), _c('td', [_vm._v("6=4-5")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-244beccc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nssb/table4.vue
// module id = 710
// module chunks = 1